<div bsModal #staticModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-static"
     [config]="{backdrop: 'static'}" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-static" class="modal-title pull-left">
                    Add a New Property
                    <span>Step {{currentStep}} of 2</span>
                </h4>

                <button type="button" class="close pull-right" (click)="onClose()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <!-- Step 1 - Property Details -->
            <div [hidden]="currentStep === 2">
                <div class="modal-body">
                    <div class="medium-padding remove-margin">

                        <sp-add-property-details
                            [formGroup]="formGroupDetails"
                            [property]="property"
                            [propertyTypes]="propertyTypes$ | async"
                            [workspaces]="workspaces$ | async"
                            [currentWorkspace]="currentWorkspace$ | async"
                            [currentWorkspaceId]="workspaceId"
                            [userProfile]="userProfile$ | async"
                            [states]="states">
                        </sp-add-property-details>

                    </div>
                </div>

                <footer>
                    <input type="button" class="btn btn-cancel" value="Cancel" (click)="onClose()" />
                    <input type="button" class="btn btn-success" value="Continue" (click)="setStep(2)" [disabled]="formGroupDetails.invalid" />
                </footer>
            </div>

            <!-- Step 2 - Property Financials -->
            <div [hidden]="currentStep === 1">
                <div class="modal-body">
                    <div class="medium-padding remove-margin">

                        <sp-add-property-financials
                            [formGroup]="formGroupFinancials"
                            [property]="property"
                            [months]="months"
                            [collectionFrequencies]="collectionFrequencies">
                        </sp-add-property-financials>

                    </div>
                </div>

                <footer>
                    <input type="button" class="btn btn-cancel" value="back" (click)="setStep(1)" />
                    <input type="button" class="btn btn-success" value="Add New Property" (click)="onSave()" [disabled]="formGroupFinancials.invalid" />
                </footer>
            </div>
        </div>
    </div>
</div>
